import React, { useState, useRef, useEffect } from "react";
import "./ComboBox.css";
import Text from "../typography/Text";

const ComboBox = ({
  label,
  options = [],
  value = [],
  onChange,
  className = "",
  multiple = true,
  ...props
}) => {
  const [selectedOptions, setSelectedOptions] = useState(value);
  const [isOpen, setIsOpen] = useState(false);
  const comboBoxRef = useRef(null);

  const toggleOption = (option) => {
    let newSelection;
    if (multiple) {
      newSelection = selectedOptions.includes(option)
        ? selectedOptions.filter((item) => item !== option)
        : [...selectedOptions, option];
    } else {
      newSelection = selectedOptions.includes(option) ? [] : [option];
    }
    setSelectedOptions(newSelection);
    onChange && onChange(newSelection);
  };

  const removeOption = (option) => {
    const newSelection = selectedOptions.filter((item) => item !== option);
    setSelectedOptions(newSelection);
    onChange && onChange(newSelection);
  };

  useEffect(() => {
    setSelectedOptions(value);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (comboBoxRef.current && !comboBoxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`ComboBox ${className}`} ref={comboBoxRef} {...props}>
      {label && (
        <label
          className="label"
          onClick={() => setIsOpen(true)}
          role="button"
          tabIndex={0}
        >
          <Text size="sm" className="text-sm">
            {label}
          </Text>
        </label>
      )}
      <div className={`container ${isOpen ? "active" : ""}`}>
        <div className="ctn-input" onClick={() => setIsOpen(!isOpen)}>
          {selectedOptions.length > 0 ? (
            selectedOptions.map((option) => (
              <span key={option} className="tag">
                {option} <button onClick={() => removeOption(option)}>×</button>
              </span>
            ))
          ) : (
            <span className="placeholder">Choisir une option...</span>
          )}
        </div>
        {isOpen && (
          <ul className="options">
            {options.map((option) => (
              <li
                key={option}
                className={selectedOptions.includes(option) ? "selected" : ""}
                onClick={() => toggleOption(option)}
              >
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ComboBox;
